import React, { useMemo } from 'react';

/* Bats: random top positions + durations so they don't all fly in sync */
const BATS = [
  { top: '12%',  duration: '18s', delay: '0s'   },
  { top: '35%',  duration: '22s', delay: '6s'   },
  { top: '55%',  duration: '16s', delay: '12s'  },
  { top: '20%',  duration: '26s', delay: '4s'   },
];

/* Falling leaves / embers */
const LEAVES = [
  { emoji: '🍂', left: '8%',  duration: '7s',  delay: '0s'  },
  { emoji: '🍁', left: '22%', duration: '9s',  delay: '2s'  },
  { emoji: '🍂', left: '45%', duration: '6s',  delay: '5s'  },
  { emoji: '🍁', left: '68%', duration: '8s',  delay: '1s'  },
  { emoji: '🍂', left: '82%', duration: '10s', delay: '3.5s'},
  { emoji: '🍁', left: '90%', duration: '7.5s',delay: '7s'  },
];

/* Ghosts sitting at fixed spots */
const GHOSTS = [
  { right: '4%',  top: '18%', duration: '4s', delay: '0s'   },
  { right: '12%', top: '62%', duration: '5s', delay: '1.5s' },
];

/* Spiders hanging from top */
const SPIDERS = [
  { left: '15%',  duration: '3s',   delay: '0s'   },
  { left: '78%',  duration: '3.8s', delay: '1.2s' },
];

/* Corner cobweb rendered as an SVG */
function Cobweb({ corner = 'top-left' }) {
  const flip = corner === 'top-right';
  return (
    <svg
      viewBox="0 0 120 120"
      width={120}
      height={120}
      style={{
        position: 'fixed',
        top: 0,
        [flip ? 'right' : 'left']: 0,
        transform: flip ? 'scaleX(-1)' : undefined,
        pointerEvents: 'none',
        zIndex: 9995,
        opacity: 0.35,
      }}
    >
      {/* Radial lines */}
      {[0, 20, 40, 60, 80].map((angle) => (
        <line
          key={angle}
          x1="0" y1="0"
          x2={120 * Math.cos((angle * Math.PI) / 180)}
          y2={120 * Math.sin((angle * Math.PI) / 180)}
          stroke="#a16207"
          strokeWidth="0.8"
        />
      ))}
      {/* Concentric arcs */}
      {[28, 56, 84, 112].map((r) => (
        <path
          key={r}
          d={`M ${r} 0 Q ${r * 0.7} ${r * 0.7} 0 ${r}`}
          fill="none"
          stroke="#a16207"
          strokeWidth="0.7"
        />
      ))}
      {/* Spider */}
      <text x="48" y="52" fontSize="12" opacity="0.8">🕷️</text>
    </svg>
  );
}

export default function HalloweenDecorations() {
  return (
    <>
      <Cobweb corner="top-left" />
      <Cobweb corner="top-right" />

      {BATS.map((b, i) => (
        <span
          key={`bat-${i}`}
          className="halloween-bat"
          style={{
            top: b.top,
            fontSize: 18,
            animationDuration: `${b.duration}, ${parseFloat(b.duration) / 4}s`,
            animationDelay: `${b.delay}, ${b.delay}`,
          }}
        >
          🦇
        </span>
      ))}

      {LEAVES.map((l, i) => (
        <span
          key={`leaf-${i}`}
          className="halloween-leaf"
          style={{
            left: l.left,
            top: '-30px',
            fontSize: 16,
            animationDuration: l.duration,
            animationDelay: l.delay,
          }}
        >
          {l.emoji}
        </span>
      ))}

      {GHOSTS.map((g, i) => (
        <span
          key={`ghost-${i}`}
          className="halloween-ghost"
          style={{
            right: g.right,
            top: g.top,
            animationDuration: g.duration,
            animationDelay: g.delay,
          }}
        >
          👻
        </span>
      ))}

      {SPIDERS.map((s, i) => (
        <span
          key={`spider-${i}`}
          className="halloween-spider"
          style={{
            left: s.left,
            animationDuration: s.duration,
            animationDelay: s.delay,
          }}
        >
          🕷️
        </span>
      ))}
    </>
  );
}
